import type { GeneratedSchemaField } from '@cli-types/core-engine/add-field.js'

export function collectRelationshipTargets(
  field: GeneratedSchemaField,
  targets: Set<string>
): void {
  if ('relationship' in field && typeof field.relationship === 'string') {
    targets.add(field.relationship)
  }

  if (field.fields) {
    for (const child of field.fields) {
      collectRelationshipTargets(child, targets)
    }
  }

  if ('tabs' in field && field.tabs) {
    for (const tab of field.tabs) {
      for (const child of tab.fields ?? []) {
        collectRelationshipTargets(child, targets)
      }
      for (const child of tab.slot?.main?.fields ?? []) {
        collectRelationshipTargets(child, targets)
      }
      for (const child of tab.slot?.sidebar?.fields ?? []) {
        collectRelationshipTargets(child, targets)
      }
    }
  }
}
